import { render, staticRenderFns } from "./DataManagerTable.vue?vue&type=template&id=2e97d289&"
import script from "./DataManagerTable.vue?vue&type=script&lang=js&"
export * from "./DataManagerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports